import { Core } from "@faire/design-tokens";
import { ShowroomTileBadge } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomTileBadge";
import { VolumePricingBadge } from "@faire/retailer-visitor-shared/components/VolumePricing/VolumePricingBadge";
import { Badge } from "@faire/web--source/slate/deprecated/Badge";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { IBadge } from "@faire/web-api--source/indigofair/badges/IBadge";
import React from "react";
import styled from "styled-components";

interface IProps {
  badge: IBadge;
  productToken?: string;
}

export const BadgeGuidepost: React.FC<IProps> = ({ badge, productToken }) => {
  if (!(badge.style?.badge_message && badge.type && badge.display_to_user)) {
    return null;
  }

  switch (badge.type) {
    case IBadge.BadgeType.SHOWROOM:
      return (
        <ShowroomTileBadge
          token={productToken}
          customEventName="product-badge"
          tooltipZIndex={1005}
        />
      );
    case IBadge.BadgeType.VOLUME_PRICING:
      return (
        <VolumePricingBadge
          discountString={badge.style.badge_message}
          className="-top-2"
        />
      );

    default:
      return (
        <StyledBadge
          content={badge.style.badge_message}
          backgroundColor={Core.surface.inverse}
        />
      );
  }
};

const StyledBadge = styled(Badge)`
  max-width: 100%;
  ${TypographyStyles({
    variant: "labelSansRegular",
    truncate: true,
    maxLines: 1,
  })}
  font-weight: 500;
  padding: ${getSpacing(3, 7)};
  cursor: pointer;
  display: block;
`;
